import './index.css'
import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'

// vite-react-ssg owns the router: it prerenders each route to static HTML at
// build time and hydrates the same tree on the client.
export const createRoot = ViteReactSSG({ routes })
